import settings from '@/constants/constants';
import { createTsRestClient } from '@montugroup/frontend-common';
import { apiV1Contract } from '@montugroup/pms-api-contracts';

type ClientType = ReturnType<typeof createTsRestClient<typeof apiV1Contract>>;

let cachedClient: ClientType | null = null;

export const getPmsTsApiV1Client = (): ClientType => {
  const pmsClientArgs = {
    baseUrl: settings.pmsApiUrl,
    baseHeaders: {},
  };

  if (!cachedClient) {
    cachedClient = createTsRestClient(apiV1Contract, 'pmsApiV1', pmsClientArgs);
  }

  return cachedClient;
};
